import React, { useState, useEffect } from 'react'
import moment from "moment";
import useLangTranslation from '../../../customHooks/languageProvider';
import useFirebase from '../../../../useFirebase';
import { useSelector } from 'react-redux';

function getLastSeen(time) {
    if (!time) return '------------------';

    const endDate = moment(); // Current date and time

    // Calculate the difference between the dates
    const duration = moment.duration(endDate.diff(time));

    // Get the time difference in days, hours, minutes, and seconds
    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    if (days > 0) {
        return `Last activity was at ${moment().format('DD/MM/YYYY HH:mm:ss')}`
    } else if (hours >= 1 && hours < 24) {
        return `From ${hours}h ago`
    } else if (minutes >= 1 && minutes < 60) {
        return `From ${minutes}m ago`
    } else if (seconds >= 0 && seconds < 60) {
        return `From ${seconds}s ago`
    }
}


const CurrentLocation = () => {
    const { selectedDeviceData } = useSelector(({ dashboard }) => dashboard);
    const { getLangTranslation } = useLangTranslation();
    const [deviceLocation, setDeviceLocation] = useState(null);
    const { getCurrentLocation } = useFirebase();

    useEffect(() => {
        async function getCurrentLocationMethod(id) {
            const deviceLocation = await getCurrentLocation(id);
            setDeviceLocation(deviceLocation);
        }

        if (selectedDeviceData) {
            getCurrentLocationMethod(selectedDeviceData?.ID);
        } else {
            setDeviceLocation(null);
        }
    }, [selectedDeviceData])

    return (
        <div className="list-item">
            <div>
                <p className="text-small text-uppercase light-text mb-1">{getLangTranslation('PARENT_CHILD_DETAIL_CURRENT_LOCATION', 'Current location')}</p>
                <p className="text-small light-text mb-1">{getLastSeen(deviceLocation?.locationTime)}</p>
                <h5 className="my-0" style={{ fontSize: '13px' }}>
                    {selectedDeviceData?.ID ? deviceLocation?.address : '---'}
                </h5>
            </div>
        </div>
    )
}

export default CurrentLocation